import type { DriveStep } from "driver.js";

export const GUESTS_TOUR_STEPS: DriveStep[] = [
  {
    element: '[data-tour="guests-search"]',
    popover: {
      title: "Gast suchen",
      description:
        "Suchen Sie in der Stammkartei nach Name, E-Mail, Telefon, Ort, Ausweisnummer oder Notizen. Mindestens zwei Zeichen erforderlich.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="guests-type-filter"]',
    popover: {
      title: "Gästetyp",
      description:
        "Filtern Sie nach Gästetyp (z. B. Tourist, Saisoncamper, Tagesgast). So finden Sie gezielt bestimmte Kundengruppen.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="guests-create"]',
    popover: {
      title: "Neuer Gast",
      description:
        "Legen Sie einen neuen Gast in der Stammkartei an. Stammdaten werden bei Buchungen und Rechnungen wiederverwendet.",
      side: "left",
      align: "center",
    },
  },
  {
    element: '[data-tour="guests-table"]',
    popover: {
      title: "Gästeliste",
      description:
        "Jeder Gast zeigt den letzten Aufenthalt. Klicken Sie auf einen Gast, um Stammdaten zu bearbeiten, die Buchungshistorie einzusehen oder Notizen zu pflegen.",
      side: "top",
      align: "start",
    },
  },
];
